import { Button, CircularProgress, IconButton } from "@mui/material";
import { useStyles } from "./styles";

const SimpleWidgetsInput = ({
    label,
    isSearch,
    placeholder,
    value,
    onChange,
    onActions,
    ActionIcon,
    actionsLabel = "",
    onKeyDown,
    actionDisabled,
    actionsLoading,
    isLoading,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.InputWrapper}>
            {label}
            <div className="InputTitle">
                <div className="InputField">
                    {isSearch && <i className="bx bx-search"></i>}
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        onKeyDown={(e) => onKeyDown?.(e)}
                    />
                </div>
                {isLoading || actionsLoading ? (
                    <CircularProgress className={classes.Loading} />
                ) : (
                    <>
                        {ActionIcon && (
                            <IconButton
                                disabled={actionDisabled}
                                onClick={onActions}
                            >
                                <ActionIcon />{" "}
                                {actionsLabel ? actionsLabel : ""}
                            </IconButton>
                        )}
                        {!isLoading && !ActionIcon && actionsLabel && (
                            <Button
                                disabled={actionDisabled}
                                onClick={onActions}
                            >
                                {actionsLabel ? actionsLabel : ""}
                            </Button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default SimpleWidgetsInput;
